import {lazy} from '@aboutyou/lazy-imports';
import {useIsBasketStateLoaded} from '@aboutyou/user';
import React, {FC} from 'react';
import {useNotifications} from '../../NotificationCenter/useNotifications';

const ShopHint = lazy(() =>
  import('../../../features/ShopHint/ShopHint').then(mod => ({
    default: mod.ShopHint,
  })),
);

export const BasketHint: FC<{
  className?: string;
  notificationBellRef: React.RefObject<HTMLDivElement | null>;
}> = ({className, notificationBellRef}) => {
  const isBasketStateLoaded = useIsBasketStateLoaded();
  const {notificationsData} = useNotifications();

  if (!isBasketStateLoaded || !notificationsData) {
    return null;
  }

  return (
    <ShopHint
      className={className}
      notificationBellRef={notificationBellRef}
      {...notificationsData}
    />
  );
};
